import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import type { SearchResultItem } from '@/features/search/types'
import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { useRecycleMediaMutation } from '../api'
import { handleReturn } from '../helpers/utils'
import {
  getMediaDetailsState,
  setMediaDetailsState,
  setModalState,
} from '../slice'

export const useRecycleMedia = () => {
  const [mediaCode, setMediaCode] = useState<number | null>(null)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const { openDrawer } = useAppSelector(getMediaDetailsState).mediaDetailsState
  const { confirm } = useAppSelector(getMediaDetailsState).modalState

  const [recycleMedia, request] = useRecycleMediaMutation()

  const handleRecycleMedia = (searchResultItem: SearchResultItem) => {
    setMediaCode(searchResultItem.mediaCode)
    dispatch(setModalState({ open: true, title: searchResultItem.title }))
  }

  useEffect(() => {
    if (confirm && mediaCode) {
      recycleMedia(mediaCode)
      dispatch(setModalState({ open: false, confirm: false }))
    }
  }, [confirm, mediaCode])

  useEffect(() => {
    dispatch(setMediaDetailsState({ isLoading: request.isLoading }))
  }, [request.isLoading])

  useEffect(() => {
    if (request.isSuccess) {
      openDrawer
        ? dispatch(
            setMediaDetailsState({ openDrawer: false, searchResultItem: null }),
          )
        : handleReturn(dispatch, navigate)
    }
  }, [request.isSuccess, openDrawer])

  return { handleRecycleMedia }
}
